export default __webpack_public_path__ + "static/media/Horiseon.d38c538c.gif";